// "XÁC MINH KHI CẦN NGƯỜI" (06/10/2026 — người dùng: "cho thêm cả xác minh khi tham gia nhóm phải trả lời câu hỏi hoặc màn hình lạ mà AI không xử lý được").
// Boss đã có cơ chế TẠM DỪNG bot cho CAPTCHA/checkpoint (bảng bot_tam_dung, nút đỏ "Giải CAPTCHA", cửa sổ điều khiển từ xa BỞI NGƯỜI, "Cho chạy lại"). Hai tình huống nữa
// cũng chỉ NGƯỜI mới làm được thì đi đúng đường đó, mã tạm dừng mới "can_nguoi":
//  (a) nhóm Facebook hỏi câu lúc xin vào mà bot KHÔNG được (đòi SĐT/email/giấy tờ… bắt buộc — không bao giờ tự điền) hoặc không thể (không đọc được hộp, AI không soạn được
//      câu hợp lệ, điền/Gửi không được) tự trả lời;
//  (b) MÀN HÌNH LẠ mà AI chịu thua: hộp che trang AI không chỉ được nút đóng an toàn; AI "không rõ" trong khi máy thấy hộp lạ che trang / tab đã sang trang ngoài kịch bản.
// Lỗi THƯỜNG (selector đổi, hết hạn, mạng) KHÔNG thuộc đây — giữ phân loại A/B. Module thuần dùng chung bot + Boss + web.
import { rutGonTieuDe, type KetQuaHopThoai } from "./hop-thoai-trang";

export const MA_CAN_NGUOI = "can_nguoi" as const;
export type LoaiCanNguoi = "cau_hoi_nhom" | "man_hinh_la";
/** Tối đa ký tự của câu nói cho người đọc (RunRecord.xacMinh.thay, lý do tạm dừng). */
export const TOI_DA_THAY = 300;
/** Tiền tố lý do dừng của bot — Boss nhận ra mã can_nguoi từ chữ này khi RunRecord.xacMinh bị mất. */
export const DAU_LY_DO_CAN_NGUOI = "CẦN BẠN XỬ LÝ:";

/** Chữ lấy từ trang đưa cho người đọc: bỏ ký tự điều khiển/xuống dòng, gom khoảng trắng, cắt theo KÝ TỰ (không tách đôi emoji), thêm "…". Không phải chuỗi → "". */
export function gonChuTrang(s: unknown, n = TOI_DA_THAY): string {
  if (typeof s !== "string") return "";
  const kt = Array.from(s.replace(/[\u0000-\u001f\u007f-\u009f]+/g, " ").replace(/\s+/g, " ").trim());
  return kt.length > n ? `${kt.slice(0, n - 1).join("")}…` : kt.join("");
}

/** (a) Câu cho người đọc khi nhóm hỏi câu bot không được / không thể tự trả lời. `lyDo` = vì sao máy không tự trả lời (nêu câu nào, vì sao). */
export function cauCanNguoiNhom(tenNhom: unknown, lyDo: unknown): string {
  const ten = gonChuTrang(tenNhom, 80) || "(không rõ tên)";
  const ly = gonChuTrang(lyDo, 200);
  return gonChuTrang(`Nhóm “${ten}” hỏi câu cần bạn tự trả lời${ly ? `: ${ly}` : ""}`);
}

/** (b) Câu cho người đọc khi gặp màn hình lạ AI chưa xử lý được. */
export function cauManHinhLa(chiTiet: unknown): string {
  const ct = gonChuTrang(chiTiet, 220);
  return gonChuTrang(`Gặp màn hình lạ AI chưa xử lý được${ct ? `: ${ct}` : ""}`);
}

// Loại hộp thoại (src/shared/hop-thoai-trang.ts) mà MÁY không tự xử lý và không phải một phần bình thường của luồng: lạ (không nút đóng), đóng được nhưng vẫn che trang,
// xác minh/đăng nhập. KHÔNG tính: ô soạn/biểu mẫu (bot tự mở), hộp bài viết, 'Xem xét quyền tham gia' (bước bình luận đã có đường riêng: bỏ mục).
const LOAI_HOP_LA: ReadonlySet<string> = new Set(["khong_nut_dong", "dong_duoc", "xac_minh"]);
const LY_DO_LOAI: Record<string, string> = { khong_nut_dong: "không có nút Đóng/X để máy bấm", dong_duoc: "vẫn che trang", xac_minh: "hộp xác minh / đăng nhập" };

export interface HopLa { tieuDe: string; loai: string }
export interface TinHieuManHinhLa {
  /** Nhãn AI chẩn đoán cuối cùng (CHAN_DOAN_NHAN ở src/background/model.ts). */
  nhan: string;
  /** Nhãn popup_can_dong mà máy KHÔNG đóng được: lý do (không chỉ được nút / nút ngoài danh sách đóng / bấm không được). Rỗng = đã đóng được. */
  popupKhongDong?: string;
  /** Chữ đặc trưng AI trích từ trang. */
  chu?: string | null;
  /** Hộp thoại đang che trang theo máy dò content (chỉ xem). */
  hop?: readonly HopLa[];
  /** Địa chỉ tab hiện tại + có nằm NGOÀI trang đích của kịch bản không. */
  url?: string;
  ngoaiTrangDich?: boolean;
}

/**
 * AI CHỊU THUA trước một màn hình lạ? Chỉ trả kết quả khi có BẰNG CHỨNG máy thấy được — không biến lỗi thường (giao diện đổi, hết hạn, mạng) thành "cần người":
 *  - popup_can_dong mà máy không đóng được (AI không chỉ được nút / nút không nằm trong danh sách nút đóng / bấm hỏng) → cần người;
 *  - khong_ro + hộp lạ che trang (loại khong_nut_dong / dong_duoc / xac_minh) → cần người;
 *  - khong_ro + tab đã sang trang http(s) NGOÀI trang đích → cần người;
 *  - mọi nhãn khác, hoặc khong_ro không có bằng chứng → null (giữ phân loại A/B như cũ).
 */
export function quyetManHinhLa(t: TinHieuManHinhLa | null | undefined): { chiTiet: string } | null {
  if (!t || typeof t !== "object") return null;
  const nhan = typeof t.nhan === "string" ? t.nhan : "";
  if (nhan === "popup_can_dong") {
    const ly = gonChuTrang(t.popupKhongDong, 180);
    if (!ly) return null;
    const chu = gonChuTrang(t.chu, 80);
    return { chiTiet: gonChuTrang(`${chu ? `thấy “${chu}” — ` : ""}${ly}`, 260) };
  }
  if (nhan !== "khong_ro") return null;
  const hop = (Array.isArray(t.hop) ? t.hop : []).filter((h): h is HopLa => !!h && typeof h === "object" && LOAI_HOP_LA.has(String(h.loai)));
  if (hop.length) {
    const h = hop[0]!;
    const them = hop.length > 1 ? ` (+${hop.length - 1} hộp khác)` : "";
    return { chiTiet: gonChuTrang(`hộp thoại “${rutGonTieuDe(h.tieuDe, 80)}” che trang (${LY_DO_LOAI[String(h.loai)] ?? "máy không tự xử lý"})${them}`, 260) };
  }
  if (t.ngoaiTrangDich === true && typeof t.url === "string" && /^https?:\/\//i.test(t.url.trim())) {
    let host = "";
    try { host = new URL(t.url.trim()).hostname; } catch { host = ""; }
    if (host) return { chiTiet: gonChuTrang(`tab đang ở trang ngoài kịch bản (${host})`, 260) };
  }
  return null;
}

/** Từ trả lời "dongHopThoai" (chiXem): các hộp còn che trang mà máy không tự xử lý (loại LOAI_HOP_LA). Hộp "đóng được" chỉ có trong conChe (chiXem không bấm) → loại dong_duoc. */
export function hopConCanXuLy(r: KetQuaHopThoai | null | undefined): HopLa[] {
  if (!r || typeof r !== "object" || !Array.isArray(r.conChe)) return [];
  const khong = new Map<string, string>();
  for (const k of Array.isArray(r.khongDong) ? r.khongDong : []) if (k && typeof k.tieuDe === "string") khong.set(k.tieuDe, String(k.loai));
  const out: HopLa[] = [];
  for (const tieuDe of r.conChe) {
    const loai = khong.get(tieuDe) ?? "dong_duoc";
    if (LOAI_HOP_LA.has(loai)) out.push({ tieuDe: String(tieuDe), loai });
  }
  return out;
}

// ---- nhãn tiếng Việt cho mã tạm dừng (trang Chờ duyệt; thẻ bot do phiên giao diện khác lo) ----
const NHAN_TAM_DUNG: Record<string, string> = {
  captcha: "CAPTCHA", checkpoint: "Tài khoản bị khoá tạm", xac_minh: "Cần xác minh", dang_xuat: "Bị đăng xuất", spam: "Bị cảnh báo spam", [MA_CAN_NGUOI]: "Cần bạn xử lý",
};
const HUONG_DAN: Record<string, string> = {
  captcha: "Giải CAPTCHA trên trình duyệt của bot (hoặc dùng cửa sổ điều khiển từ xa của thẻ bot) rồi bấm Cho chạy lại.",
  checkpoint: "Xác nhận tài khoản trên trình duyệt của bot rồi bấm Cho chạy lại.",
  xac_minh: "Xác minh tài khoản trên trình duyệt của bot rồi bấm Cho chạy lại.",
  dang_xuat: "Đăng nhập lại trên trình duyệt của bot rồi bấm Cho chạy lại.",
  spam: "Xem lại tài khoản trên trình duyệt của bot rồi bấm Cho chạy lại.",
  [MA_CAN_NGUOI]: "Bot dừng vì gặp câu hỏi của nhóm hoặc màn hình mà máy không tự xử lý được (máy không bao giờ tự điền thông tin cá nhân). Mở cửa sổ điều khiển từ xa của thẻ bot, tự trả lời câu hỏi / xử lý màn hình đó rồi bấm Cho chạy lại.",
};
const coKhoa = (o: Record<string, string>, ma: unknown): ma is string => typeof ma === "string" && Object.prototype.hasOwnProperty.call(o, ma);
/** Nhãn ngắn của mã tạm dừng. Mã lạ / rỗng → nhãn chung. */
export function nhanTamDung(ma: unknown): string {
  return coKhoa(NHAN_TAM_DUNG, ma) ? NHAN_TAM_DUNG[ma]! : "Cần xử lý trên máy bot";
}
/** Câu hướng dẫn người dùng làm gì với lần tạm dừng này. */
export function huongDanTamDung(ma: unknown): string {
  return coKhoa(HUONG_DAN, ma) ? HUONG_DAN[ma]! : "Xử lý xong trên trình duyệt của bot rồi bấm Cho chạy lại.";
}
